module.exports = __webpack_public_path__ + "yz/img/logo.cfb537ad.png";